import { NumberDisplayFormat } from '@teko/types/dist/ecommerce';
import { DEFAULT_NUMBER_DISPLAY_FORMAT } from 'constants/index';
import { useTenantConfig } from '../contexts';

export const useFormatNumber = (numberFormat?: NumberDisplayFormat) => {
  const { numberDisplayFormat: _numberDisplayFormat } = useTenantConfig();
  const numberDisplayFormat: NumberDisplayFormat = {
    ...DEFAULT_NUMBER_DISPLAY_FORMAT,
    ...(_numberDisplayFormat ?? {}),
    ...(numberFormat ?? {}),
  };

  const formatNumber = (number: number) => {
    if (!numberDisplayFormat) {
      return undefined;
    } else {
      // split decimal part
      const part = number.toString().split('.');
      // add thousand separator
      let res = part[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        numberDisplayFormat.thousandSeparator,
      );
      // add decimal separator
      if (part[1]) res = res + numberDisplayFormat.decimalSeparator + part[1];
      return res;
    }
  };

  return formatNumber;
};
